import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserRoleCode = createSelector(
  [(store: RootState) => store.userTemplate.userRoleCode],
  (data) => data
);
